import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { VersionCheckService } from './services/version-check.service';
import { RumInitializerService } from './services/rum/rum-initializer.service';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    imports: [RouterOutlet, LoadingSpinnerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'admin-aquaforms';
  private versionCheckService = inject(VersionCheckService);
  private router = inject(Router);
  private rumService = inject(RumInitializerService);

  // Field initializer: takeUntilDestroyed() infiere DestroyRef del contexto de inyeccion
  private pageViewTracking = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    takeUntilDestroyed()
  ).subscribe(event => {
    const url = event.urlAfterRedirects;
    this.rumService.recordPageView(url, [this.getSection(url)]);
  });

  private getSection(url: string): string {
    if (url.includes('/mantenedores/persona')) return 'personas';
    if (url.includes('/mantenedores/centro')) return 'centros';
    if (url.includes('/mantenedores/logs')) return 'logs';
    if (url.includes('/mantenedores/inicio')) return 'inicio';
    if (url.includes('/about')) return 'about';
    if (url.includes('/login')) return 'auth';
    return 'other';
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.versionCheckService.initVersionCheck();
    }, 1000);
  }
}
